// extracted by mini-css-extract-plugin
export default {"title":"navbar_title__oNs--","navbarChoices":"navbar_navbarChoices__yQGYj"};